import React from "react";
import "../Experiences/ExperiencesCard.css";

function ExperiencesCard({ experience }) {
  return (
    <div className="card">
      <div>
        <img src={experience.logo} alt="company" />
      </div>
      <div className="info">
        <div className="top-info">
          <h3>{experience.position}</h3>
          <p>{`${experience.company} `}</p>
        </div>
        <div className="bottom-info">
          <p>{`${experience.from} - ${experience.until} : ${experience.period} - ${experience.employmentType}`}</p>
          <p>{experience.location}</p>
        </div>
      </div>
    </div>
  );
}

export default ExperiencesCard;

// {
//     position: "Integration Trainer",
//     employmentType: "Full-time",
//     company: "VluchtelingenWerk Nederland",
//     from: "May 2016",
//     until: "Jul 2017 ",
//     period: "1 year & 3 months",
//     location: "The Hague - The Netherlands",
//     keys: ["presentation", "teaching"],
//   },
